import { render } from "./Statement.vue?vue&type=template&id=d2c4d826&scoped=true"
import script from "./Statement.vue?vue&type=script&lang=js"
export * from "./Statement.vue?vue&type=script&lang=js"

import "./Statement.vue?vue&type=style&index=0&id=d2c4d826&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2c4d826"

export default script